// extracted by mini-css-extract-plugin
export default {"recipientDetails":"RecipientDetails_recipientDetails__NoZlx","row":"RecipientDetails_row__MV-Bj","label":"RecipientDetails_label__FlFku"};